// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"d07bf18b","475":"ea0700c5","687":"fbd814a8","761":"fbd814a8","996":"cbacf1b8"}[chunkId] + ".chunk.css";
};